import step1 from '../../assets/img/OnboardingSection/1.png';
import step2 from '../../assets/img/OnboardingSection/2.png';
import step3 from '../../assets/img/OnboardingSection/3.png';
import step4 from '../../assets/img/OnboardingSection/4.png';

const OnboardingSection = ({
  title = <><span className="text-primary">Onboarding simplified:</span> Get started with your custom solutions</>,
  description = "Scan to BIM service company strategic planning and flexible engagement models make starting your project effortless. Here's our seamless process to kick off your architecture bim solution.",
  buttonText = "Choose Your Model",
  steps = [
    {
      step: "Step 1",
      title: "Requirement review",
      desc: "We start by understanding the project scope, model purpose, disciplines involved, target LOD, and required output formats.",
      icon: step1
    },
    {
      step: "Step 2",
      title: "Scan data assessment",
      desc: "We review the quality, coverage, and registration status of the point cloud before modeling begins.",
      icon: step2
    },
    {
      step: "Step 3",
      title: "Point cloud processing",
      desc: "The scan data is aligned, cleaned, and prepared to support accurate model development.",
      icon: step3
    },
    {
      step: "Step 4",
      title: "BIM modeling",
      desc: "We create the model in the required platform, typically Revit, based on your project goals and scope definition.",
      icon: step4
    },
    {
      step: "Step 5",
      title: "Quality control",
      desc: "The model is reviewed for geometry alignment, consistency, completeness, and project-specific standards before delivery.",
      icon: step4
    },
    {
      step: "Step 6",
      title: "Final delivery",
      desc: "We issue the model and supporting deliverables in the formats required for design, coordination, documentation, or handover use.",
      icon: step4
    },
  ]
}) => {
  return (
    <section className="onboarding-section">
      <div className="onboarding-container">
        <div className="onboarding-left">
          <div className="onboarding-sticky-wrapper">
            <h2 className="onboarding-title">
              {title}
            </h2>
            <p className="onboarding-text">
              {description}
            </p>
            <button className="onboarding-cta">{buttonText}</button>
          </div>
        </div>

        <div className="onboarding-right">
          <div className="timeline-list">
            {steps.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-icon-wrapper">
                  <img
                    src={item.icon.src || item.icon}
                    alt={`${item.step} Icon`}
                    className="timeline-icon-img"
                  />
                </div>
                <div className="timeline-content">
                  <p className="timeline-step">{item.step}</p>
                  <h4 className="timeline-title">{item.title}</h4>
                  <p className="timeline-desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnboardingSection;
